import React from 'react';

export interface CrossIconProps extends React.SVGProps<SVGSVGElement> {}

const CrossIcon: React.FC<CrossIconProps> = props => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.71373 9.78578L10.2852 1.21436"
      stroke="#2B3F6C"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.71373 1.21446L10.2852 9.78589"
      stroke="#2B3F6C"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CrossIcon;
